module.exports = __webpack_public_path__ + "static/bdd-cf46ad02ff369bcda83ea56e2540c2cd.png";